import { useState } from 'react';
import { Modal, Form, Upload, Input, App } from 'antd';
import type { UploadFile } from 'antd';
import { Upload as UploadIcon } from 'lucide-react';
import { documentService } from '@/services/documentService';

interface Props {
  documentId: string;
  currentVersion: number;
  onClose: () => void;
  onUploaded: () => void;
}

export function UploadVersionModal({ documentId, currentVersion, onClose, onUploaded }: Props) {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    const values = await form.validateFields();
    const file = fileList[0]?.originFileObj as File;
    if (!file) {
      message.warning('Chưa chọn file');
      return;
    }
    setSubmitting(true);
    try {
      await documentService.uploadVersion(documentId, file, values.changeNote);
      message.success(`Đã upload phiên bản v${currentVersion + 1}`);
      onUploaded();
    } catch (e: any) {
      message.error(e.response?.data?.message ?? 'Lỗi upload');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open
      title={`Upload phiên bản mới (sẽ là v${currentVersion + 1})`}
      onCancel={onClose}
      onOk={submit}
      confirmLoading={submitting}
      okText="Upload"
      cancelText="Hủy"
      width={560}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item label="File mới" required>
          <Upload.Dragger
            fileList={fileList}
            beforeUpload={() => false}
            maxCount={1}
            onChange={({ fileList }) => setFileList(fileList.slice(-1))}
            onRemove={() => { setFileList([]); return true; }}
          >
            <div style={{ padding: 20 }}>
              <UploadIcon size={28} style={{ color: '#6699CC' }} />
              <div style={{ marginTop: 10, fontSize: 13 }}>Kéo thả file hoặc bấm để chọn</div>
              <div style={{ fontSize: 11, color: '#8a95a5' }}>Tối đa 100MB</div>
            </div>
          </Upload.Dragger>
        </Form.Item>

        <Form.Item name="changeNote" label="Ghi chú thay đổi"
          rules={[{ required: true, message: 'Ghi lại lý do đổi phiên bản' }]}>
          <Input.TextArea rows={3}
            placeholder="VD: Cập nhật điều khoản 3.2 theo yêu cầu BGĐ, sửa lỗi chính tả trang 5..." />
        </Form.Item>
      </Form>
    </Modal>
  );
}
